// extracted by mini-css-extract-plugin
export default {"botonGoogle":"LoginGoogle_botonGoogle__aMa14","logoGoogle":"LoginGoogle_logoGoogle__-zqp3"};